import React from 'react';
import { Col } from 'react-bootstrap';
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import warning from "../../assets/images/warning.svg";
  
const columns = [
    {
        className: "pmp_column",
        field: "DSBP_PMP_PIMaterialNumber",
        header: "PMP",
    },
    {
        className: "pmp_description_column",
        field: "DSBP_PMP_PIMaterialDescription",
        header: "PMP Description",
        body: (rowData) => (
        <span className="ellipsis-text" title={rowData.DSBP_PMP_PIMaterialDescription}>
            {rowData.DSBP_PMP_PIMaterialDescription}
        </span>
        ),
    },
];

const renderColumns = (columns) => {
    return columns.map(({ className, field, header, body }) => (
        <Column
        key={field}
        className={className}
        field={field}
        header={header}
        body={body}
        />
    ));
};

const PmpTable = ({ pmps, className }) => (
    <DataTable
        value={pmps}
        dataKey="id"
        scrollable
        className={className}
        frozenHeader
    >
        {renderColumns(columns)}
    </DataTable>
);

export const PmpMessage = ({ message, className, iconClassName}) => (
  <div className="invalid-pmp-message-container">
    <img src={warning} alt="warning icon" className={ iconClassName ? iconClassName : "" } />
    <p className={className}>{message}</p>
  </div>
);

const MassUpdateCICMappingTable = ({ validPmpsSelected, invalidPmpsSelected, invalidPmpMessage }) => (
  <Col sm={8}>
    {validPmpsSelected?.length > 0 && (
      <>
        <PmpTable
          pmps={validPmpsSelected}
          className={`${invalidPmpsSelected?.length ? "half-height" : "full-height"} custom-datatable valid-pmps`}
        />
        <p className="selected-count">{validPmpsSelected?.length} Selected</p>
      </>
    )}
    {invalidPmpsSelected?.length > 0 && (
      <>
        <PmpMessage message={invalidPmpMessage} className="invalid-pmp-message"/>
        <PmpTable
          pmps={invalidPmpsSelected}
          className={`${validPmpsSelected?.length ? "half-height" : "full-height"} custom-datatable invalid-pmps`}
        />
        <p className="selected-count">{invalidPmpsSelected?.length} Selected</p>
      </>
    )}
  </Col>
);

export default MassUpdateCICMappingTable;
